<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="col-12">
              <div class="row">
                <div class="col-12 py-3 px-4 pt-4">
                  <div
                    class="col-xl-10 d-flex justify-content-between m-auto px-0 px-lg-4"
                  >
                    <h3
                      class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                    >
                      Modificar Pago
                    </h3>
                    <div class="">
                      <button
                        class="mt-2 btn-sm bg-primary text-white font-weight-normal border btn-outline-primary h5 btn d-flex flex-nowrap align-items-center"
                        @click.prevent="returnUrl"
                      >
                        <i class="bi bi-arrow-left mr-1"></i>
                        Volver
                      </button>
                    </div>
                  </div>
                  <form>
                    <div class="col-12 col-xl-10 px-0 pl-sm-3 m-auto">
                      <div class="row">
                        <div
                          class="col-12 col-md-6 pr-md-2 pl-md-2 pr-0 pl-0 py-0"
                        >
                          <div>
                            <label for="">Empresa</label>
                            <Multiselect
                              v-model="form.selected_company"
                              :options="companys"
                              label="company_name"
                              :show-labels="false"
                              placeholder="Seleccione una Opción"
                              id="typeStatus"
                              class="mt-1 mb-2"
                              disabled
                            ></Multiselect>
                          </div>
                          <div>
                            <label for="">Cobro</label>
                            <Multiselect
                              v-model="form.id_payment_fee"
                              :options="payment_fees"
                              label="title"
                              :show-labels="false"
                              placeholder="Seleccione una Opción"
                              id="typeStatus"
                              class="mt-1 mb-2"
                              @select="loadExpectedAmount($event)"
                              @remove="removeCurrency($event)"
                              disabled
                            ></Multiselect>
                          </div>
                          <div>
                            <label for="">Banco</label>
                            <Multiselect
                              v-model="form.bank"
                              :options="banks"
                              label="bank_name"
                              :show-labels="false"
                              placeholder="Seleccione un Banco"
                              id="typeStatus"
                              class="mt-1 mb-2"
                            ></Multiselect>
                          </div>

                          <div id="app" class="mt-4">
                            <file-pond
                              name="test"
                              ref="filePond"
                              label-idle="Agrega la imagen a cambiar del comprobante aquí"
                              v-bind:allow-multiple="false"
                              accepted-file-types="image/jpeg, image/png, application/pdf"
                              :server="null"
                              v-bind:files="form.url_image"
                              @addfile="handleFileAdd"
                              @removefile="handleFileRemove"
                            />
                          </div>
                          <div class="row">
                            <label class="w-100 mt-2 mb-2"
                              >Imagen actual del comprobante</label
                            >
                            <div class="m-auto border rounded p-2">
                              <img :src="img" alt="" class="rounded w-100" />
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-12 col-md-6 pl-md-2 pr-md-2 pl-0 pr-0 py-0"
                        >
                          <div>
                            <label for="">Fecha de Cobranza</label>
                            <input
                              type="date"
                              class="form-control form-control-sm mt-1 mb-2 font-weight-bold border-info"
                              v-model="form.created_at"
                              readonly
                            />
                          </div>
                          <div>
                            <label for="">Fecha de Pago</label>
                            <input
                              type="date"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.payment_date"
                              required
                            />
                          </div>
                          <div>
                            <label for="">Tasa de cambio BCV</label>
                            <input
                              type="text"
                              ref="priceInput"
                              placeholder="Tasa BCV"
                              class="form-control form-control-sm mt-1 mb-4"
                              v-model="form.current_bcv_rate"
                              v-format-price
                              required
                            />
                          </div>
                          <div>
                            <table class="table table-sm table-bordered mb-0">
                              <thead class="thead-light">
                                <tr class="text-center">
                                  <th class="py-1 px-2">Título</th>
                                  <th class="py-1 px-2">Monto</th>
                                  <th class="py-1 px-2">IVA</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="py-1 px-2">{{ form.title }}</td>
                                  <td class="py-1 px-2">
                                    {{ form.expected_amount }}
                                  </td>
                                  <td class="py-1 px-2">
                                    {{ form.iva_amount }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="py-1 px-2">Delivery</td>
                                  <td class="py-1 px-2">
                                    {{
                                      parseFloat(
                                        form.delivery_amount || '0.00'
                                      ).toFixed(2)
                                    }}
                                  </td>
                                  <td class="py-1 px-2">
                                    {{
                                      parseFloat(
                                        form.delivery_amount_taxed || '0.00'
                                      ).toFixed(2)
                                    }}
                                  </td>
                                </tr>
                                <tr class="table-info">
                                  <th class="py-1 px-2">Sub-total</th>
                                  <td class="py-1 px-2">
                                    {{
                                      (
                                        parseFloat(
                                          form.expected_amount || '0.00'
                                        ) +
                                        parseFloat(
                                          form.delivery_amount || '0.00'
                                        )
                                      ).toFixed(2)
                                    }}
                                  </td>
                                  <td class="py-1 px-2">
                                    {{
                                      (
                                        parseFloat(form.iva_amount || '0.00') +
                                        parseFloat(
                                          form.delivery_amount_taxed || '0.00'
                                        )
                                      ).toFixed(2)
                                    }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div
                              class="d-flex justify-content-between border border-info w-100 px-2 py-1 mb-0"
                              style="background-color: #c0ebfc"
                            >
                              <h5 class="font-weight-bold my-0">
                                Monto total a pagar:
                              </h5>
                              <h5 class="font-weight-bold my-0">
                                {{ parseFloat(totalAmount) }}
                              </h5>
                            </div>
                            <div
                              class="d-flex justify-content-between border border-success w-100 px-2 py-1 mb-4"
                              style="background-color: #bcffc4"
                            >
                              <h5 class="font-weight-bold my-0">Moneda:</h5>
                              <h5 class="font-weight-bold my-0">
                                {{ currency }}
                              </h5>
                            </div>
                          </div>
                          <div class="mb-3">
                            <button 
                              type="button" 
                              class="w-100 pdf-button" 
                              @click="generatePDF"
                            >
                              <i class="bi bi-file-earmark-pdf-fill mr-2"></i>
                              Generar PDF
                            </button>
                          </div>
                          
                          <div>
                            <label for="">Número de referencia</label>
                            <input
                              type="email"
                              placeholder="Referencia del pago"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.reference_number"
                              required
                            />
                          </div>

                          <div>
                            <label for="">Monto pagado ( Bs )</label>
                            <input
                              type="text"
                              ref="priceInput"
                              placeholder="Monto"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.amount"
                              v-format-price
                              required
                            />
                          </div>
                          <div>
                            <label for="">Estado de pago</label>
                            <Multiselect
                              v-model="form.id_type_payment_status"
                              :options="type_payment_status"
                              label="name"
                              :show-labels="false"
                              placeholder=""
                              id="typeStatus"
                              class="mt-1 mb-2"
                            ></Multiselect>
                          </div>
                          <div>
                            <label for="">Observación</label>
                            <textarea
                            rows="3"
                              placeholder="Observación"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.observation"
                            />
                          </div>
                          <div v-if="form.id_type_payment_status.id == 4">
                            <label for=""> Motivo de rechazo </label>
                            <textarea
                              placeholder="Monto por pagar"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.rejected_reason"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                      <div
                        class="col-12 col-xl-10 d-flex justify-content-end w-100 mt-2"
                      >
                        <button
                          class="bg-primary text-white font-weight-normal border btn-outline-primary h5 btn mb-0 mt-md-0 mb-2 mt-1"
                          @click.prevent="updateElement"
                        >
                          Modificar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'
import Cookies from 'js-cookie'

// Import MultiSelect
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  name: 'app',
  data() {
    return {
      img: null,
      form: {
        title: '',
        url_image: [],
        selected_company: '',
        created_at: '',
        payment_date: '',
        bank: '',
        amount: '',
        expected_amount: '',
        current_bcv_rate: '',
        reference_number: '',
        id_payment_fee: '',
        id_admin_approval: '',
        id_type_payment_status: '',
        rejected_reason: '',
        delivery_amount: '',
        iva_amount: '',
        delivery_amount_taxed: '',
        observation: ''
      },
      companys: [],
      payment_fees: [],
      banks: [],
      type_payment_status: [],

      currency: ''
    }
  },
  components: {
    FilePond,
    Multiselect
  },
  computed: {
    totalAmount() {
      return (
        parseFloat(this.form.expected_amount || '0.00') +
        parseFloat(this.form.delivery_amount || '0.00') +
        parseFloat(this.form.iva_amount || '0.00') +
        parseFloat(this.form.delivery_amount_taxed || '0.00')
      ).toFixed(2)
    }
  },
  methods: {
    ...mapActions(['getData', 'updateData', 'optimizeImage']),

    handleFileAdd(file) {
      this.form.url_image = file.file
    },

    handleFileRemove(file) {
      this.form.url_image = []
    },

    getElement(id) {
      this.getData({ url: `payment/${id}` })
        .then((response) => {
          console.log('Datos del JSON:', response.data)
          console.log('expected_amount del JSON:', response.data.payment_fee.expected_amount)
          console.log('Tipo de expected_amount:', typeof response.data.payment_fee.expected_amount)
          
          const bankResponse = () => {
            for (const element of this.banks) {
              if (element.bank_name == response.data.payment_bank_name) {
                return element
              }
            }
            return null
          }

          this.form = {
            selected_company: {
              id_user: response.data.id_user,
              id_company: response.data.company.id,
              company_name: response.data.company.company_name
            },
            observation: response.data.observation,
            title: response.data.payment_fee.title,
            created_at: response.data.created_at.split(' ')[0],
            payment_date: response.data.payment_date,
            bank: bankResponse(),
            amount: response.data.amount == 'null' ? '' : response.data.amount,
            expected_amount: parseFloat(String(response.data.payment_fee.expected_amount || 0).replace(',', '.')).toFixed(2),
            current_bcv_rate:
              response.data.current_bcv_rate == 'null'
                ? ''
                : response.data.current_bcv_rate,
            reference_number:
              response.data.reference_number == 'null'
                ? ''
                : response.data.reference_number,
            id_payment_fee: response.data.payment_fee,
            id_type_payment_status: response.data.type_payment_status,
            id_admin_approval: Cookies.get('id'),
            rejected_reason: response.data.rejected_reason,
            delivery_amount: parseFloat(String(response.data.delivery_amount || 0).replace(',', '.')).toFixed(2),
            iva_amount: parseFloat(String(response.data.iva_amount || 0).replace(',', '.')).toFixed(2),
            delivery_amount_taxed: parseFloat(String(response.data.delivery_amount_taxed || 0).replace(',', '.')).toFixed(2)
          }

          this.img = response.data.url_image
          this.currency = response.data.type_currency.name
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async loadCompanys() {
      const form = {
        url: 'user/all',
        params: {
          active: 1
        }
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.companys = response.data
              .filter((user) => user.company && user.id_company != 0)
              .map((user) => ({
                id_user: user.id,
                id_company: user.company.id,
                company_name: user.company.company_name
              }))
              .sort((a, b) => a.company_name.localeCompare(b.company_name))
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadPaymentFees() {
      const form = {
        url: 'payment_fee/all',
        params: {}
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.payment_fees = response.data.filter(
              (item) => item.active === 1
            )
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async loadBanks() {
      const form = {
        url: 'cilara_bank/all',
        params: {}
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.banks = response.data.sort((a, b) =>
              a.bank_name.localeCompare(b.bank_name)
            )
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadTypePaymentStatus() {
      const form = {
        url: 'type_payment_status/all',
        params: {
          active: 1
        }
      }

      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.type_payment_status = response.data
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    isFormValid(form) {
      return (
        form.selected_company != null &&
        form.selected_company !== '' &&
        form.payment_date != null &&
        form.payment_date !== '' &&
        form.bank != null &&
        form.bank !== '' &&
        form.amount != null &&
        form.amount !== '' &&
        form.amount !== 0 &&
        form.expected_amount != null &&
        form.expected_amount !== '' &&
        form.current_bcv_rate != null &&
        form.current_bcv_rate !== '' &&
        form.current_bcv_rate !== 0 &&
        form.reference_number != null &&
        form.reference_number !== '' &&
        form.id_payment_fee != null &&
        form.id_payment_fee !== '' &&
        form.id_admin_approval != null &&
        form.id_admin_approval !== '' &&
        form.id_admin_approval !== 0 &&
        form.id_type_payment_status != null &&
        form.id_type_payment_status !== ''
      )
    },
    updateElement() {
      if (!this.isFormValid(this.form)) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, complete todos los campos para continuar.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      if (
        this.form.id_type_payment_status.id == 4 &&
        (this.form.rejected_reason == '' || this.form.rejected_reason == null)
      ) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, ingresa un motivo de rechazo.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      const today = new Date().toISOString().split('T')[0]
      const paymentDate = this.form.payment_date

      if (paymentDate > today) {
        Swal.fire({
          title: 'Fecha inválida',
          text: 'No se puede introducir una fecha mayor a la actual.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }

      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de guardar los cambios?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,

        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, Guardar'
      }).then(async (result) => {
        if (result.value) {
          const formData = new FormData()

          const filePondInstance = this.$refs.filePond.getFiles()
          if (filePondInstance[0] && filePondInstance[0].file) {
            const compressedImage = await this.optimizeImage(
              filePondInstance[0].file
            )
            formData.append('url_image', compressedImage)
          }

          formData.append('id_company', this.form.selected_company.id_company)
          formData.append(
            'company_name',
            this.form.selected_company.company_name
          )
          formData.append('id_user', this.form.selected_company.id_user)
          formData.append('payment_date', this.form.payment_date)
          formData.append('payment_bank_name', this.form.bank.bank_name)
          formData.append('amount', this.form.amount)
          formData.append('current_bcv_rate', this.form.current_bcv_rate)
          formData.append('reference_number', this.form.reference_number)
          formData.append('observation', this.form.observation)
          formData.append('id_admin_approval', this.form.id_admin_approval)
          formData.append(
            'id_type_payment_status',
            this.form.id_type_payment_status.id
          )
          formData.append('id_payment_fee', this.form.id_payment_fee.id)
          formData.append('title', this.form.id_payment_fee.title)

          if (this.form.rejected_reason) {
            formData.append('rejected_reason', this.form.rejected_reason)
          }

          const form = {
            url: 'payment/update',
            id: this.$route.params.id,
            data: formData
          }

          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: 'Elemento Guardado correctamente',
                  icon: 'success',

                  confirmButtonText: 'Aceptar'
                }).then(() => {
                  this.returnUrl()
                })
              } else if (response.code === 409) {
                Swal.fire({
                  title: 'Error',
                  text: 'Ya existe un elemento con ese título.',
                  icon: 'error',

                  confirmButtonText: 'Aceptar'
                })
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error, intente más tarde.',
                icon: 'error',

                confirmButtonText: 'Aceptar'
              })
            })
        }
      })
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword
    },
    returnUrl() {
      this.$router.go(-1)
    },

    loadExpectedAmount(event) {
      this.form.expected_amount = event.expected_amount
      this.currency = event.type_currency.name || ''
    },
    removeCurrency(event) {
      this.form.expected_amount = ''
      this.currency = ''
    },
    
    generatePDF() {
      const paymentId = this.$route.params.id;
      
      // Mostrar indicador de carga
      Swal.fire({
        title: 'Generando PDF',
        text: 'Por favor espere...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        }
      });
      
      const form = {
        url: `analitic/proform/${paymentId}`,
        params: {}
      };
      
      this.getData(form)
        .then(response => {
          if (response.code === 200) {
            // Si la respuesta contiene el enlace pdf_link para descargar el PDF
            if (response.data && response.data.pdf_link) {
              // Cerrar el indicador de carga
              Swal.close();
              
              // Abrir el PDF en una nueva pestaña
              window.open(response.data.pdf_link, '_blank');
            } else {
              // Si no hay enlace, mostrar mensaje de éxito y posible contenido
              Swal.fire({
                icon: 'success',
                title: 'PDF generado',
                text: 'El PDF se ha generado correctamente'
              });
            }
          } else {
            // Mostrar mensaje de error
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se pudo generar el PDF. Por favor, intente nuevamente.'
            });
          }
        })
        .catch(error => {
          console.error('Error al generar PDF:', error);
          
          // Mostrar mensaje de error
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al generar el PDF. Por favor, intente nuevamente.'
          });
        });
    }
  },

  async mounted() {
    await this.loadBanks()
    await this.getElement(this.$route.params.id)
    await this.loadCompanys()
    await this.loadPaymentFees()
    await this.loadTypePaymentStatus()
  }
}
</script>

<style>
.filepond--credits {
  display: none;
}

.pdf-button {
  transition: all 0.3s ease;
  background-color: white;
  color: #007bff;
  border: 1px solid #007bff;
  padding: .375rem .75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: .25rem;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  display: inline-block;
  font-weight: 400;
}

.pdf-button:hover {
  background-color: #007bff;
  color: white;
  border: 1px solid #007bff;
  text-decoration: none;
}

.pdf-button:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.pdf-button:hover i {
  color: white;
}
</style>
